<template>
    <div id="residence-agreement-form">
        <v-card elevation="0">
            <v-card-title>
                King’s University College - Rules of Residence
            </v-card-title>
            <VersionMay2025 />
            <v-card-text class="pt-0 pb-0">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-checkbox
                                v-model="item.rulesOfResidence.signed"
                                label="By accepting my residence offer and paying the required deposit, I acknowledge that I have read, understood, and agree to abide by the Rules of Residence. I understand that these rules are subject to change."
                                true-value="yes"
                                false-value="no"
                                readonly
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import VersionMay2025 from "../../../OnlineResidenceApplication/RulesOfResidence/May2025.vue"
export default {
    name: 'rules-of-residence',
    components: {
        VersionMay2025
    },
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            agreed: false,
            version: '1',
        }
    },
    methods: {
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        successColor() {
            return '#1bc5bd';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.applicant__commonname {
    font-size: 20px;
    font-weight: bold;
    text-decoration: underline;
}
</style>